import { selectIsSegmentCardinalityImprovementsFeatureFlagOn } from 'core/userContext';
import { useMetricsContext } from 'modules/productAnalytics/context';
import { Metric } from 'modules/messagingInsights/types';
import { useSelector } from 'react-redux';
import { EMAIL_LIST_ID_COL, SEGMENT_COL } from '../constants';

type CAMetricOption = {
  id: string;
  categoryId: string;
  label: string;
  value: string;
};

/**
 * BE returns the top 250 segments based on a given metric. In the case where
 * the user is already actively sorting by a metric, use that metric do dictate
 * the segments.  If they are sorting by the segment name or email list id,
 * use the user's first selected metric instead.
 */
export const useSegmentSortByParam = (
  tableSortBy: string,
  firstSelectedMetric: string,
  CAMetrics?: CAMetricOption[],
) => {
  const isSegCardinalityFFOn = useSelector(selectIsSegmentCardinalityImprovementsFeatureFlagOn);
  const { analyticsMetrics, highLevelMetrics } = useMetricsContext();

  if (!isSegCardinalityFFOn) {
    return {};
  }

  const nonMetricCols = [SEGMENT_COL, EMAIL_LIST_ID_COL];
  const sortBy = nonMetricCols.includes(tableSortBy) ? firstSelectedMetric : tableSortBy;
  const metricMatch = (metric: Metric) =>
    metric.metricNiceName === sortBy || metric.metricName === sortBy;

  if (CAMetrics) {
    const AMMetricCA = CAMetrics.find(
      (metric) => metric.value === sortBy || metric.label === sortBy,
    );

    if (AMMetricCA) {
      return { sortByMediumMetric: { name: AMMetricCA.value } };
    }
  }

  const AMMetric = analyticsMetrics.find(metricMatch);
  if (AMMetric) {
    return { sortByMediumMetric: { name: AMMetric.metricName } };
  }

  const HLMMetric = highLevelMetrics.find(metricMatch);
  if (HLMMetric) {
    return { sortByOverallMetric: { enumName: HLMMetric.metricName } };
  }

  return {};
};
